<template lang="pug">
  transition(appear)
    router-link(:to="item.url").CollectionDrawerListItem
      .CollectionDrawerListItem_details
        img(:src="item.thumbnail")
        .CollectionDrawerListItem_detailsWrapper
          .CollectionDrawerListItem_cache
          p.CollectionDrawerListItem_see
            TextAutoResize {{ $tc('collection.drawer_see') }}
          p.CollectionDrawerListItem_ref
            | {{ item.name }}
            br
            | {{ item.subtitle }}

      p.CollectionDrawerListItem_title {{ item.subtitle }}
</template>

<script>

import TextAutoResize from '@/components/common/TextAutoResize'

export default {
  props: ['item'],
  components: { TextAutoResize },
  data () {
    return {}
  },
  mounted () {

  }
}

</script>

<style lang="stylus" scoped>

  .CollectionDrawerListItem

    text-align center
    position relative
    box-sizing border-box
    text-decoration none
    width 100%
    margin 10px

    &.v-enter
      opacity 0
      transform translate3d(0, 200px, 0)

    &.v-enter-active
      transition all 1.2s $ease

    @media $mq_m
      margin 15px
      width calc(100%/2 - 2*15px)

    @media $mq_l
      margin 20px
      width calc(100%/3 - 2*20px)

    &_title

      // text-transform uppercase
      color $black
      margin-top 10px
      letter-spacing: 2px;
      transition all 0.6s $ease

      @media $mq_s_only
        font-size 14px

      @media $mq_m
        margin-top 15px

      @media $mq_l
        margin-top 20px

    &_details
      position relative
      background-color $grey-1
      background-size cover
      background-position center

      img
        top 0
        left 0
        width 100%
        height 100%
        position absolute
        object-fit cover

      &::before
        content ''
        display: block
        position: relative
        padding-bottom 82.36% // create parent fix ratio

    &_detailsWrapper
      position: absolute
      top 0
      right 0
      bottom 0
      left 0
      display flex
      box-sizing border-box
      padding 20px
      flex-direction column
      align-items center
      justify-content center

    &_ref

      color white
      opacity 0
      transform translateY(100%)
      transition all 1s $ease
      position relative
      margin-top 0px

    &_see

      color $beige
      opacity 0
      transform translateY(100%)
      transition all 1s $ease
      position relative
      text-transform uppercase
      margin-bottom 20px
      font-weight 600
      font-size: 18px;
      letter-spacing: 1px;
      text-align: center;

    &_cache

      position absolute
      top 0px
      left 0px
      width 100%
      height 100%
      background-color $black
      opacity 0
      transition opacity 2s $ease

    &:hover

      .CollectionDrawerListItem

        &_cache

          opacity 0.75

        &_title

          opacity 0

        &_ref

          opacity 1
          transition-delay 0.3s
          transform translateY(0%)

        &_see

          opacity 1
          transition-delay 0.2s
          transform translateY(0%)

</style>
